import { PageRef } from 'providers/page-ref';

export type WeeklyCheckupPageParams = {
  id: string; // ID of the weekly checkup log entry
};

export const IWeeklyCheckupPage: PageRef<WeeklyCheckupPageParams, void> = {
  pageName: 'WeeklyCheckupPage',
} as PageRef<WeeklyCheckupPageParams, void>;
